import React, { useEffect, useState } from "react";
import axios from "axios";
import serverConfig from "../config";
import "./BoardOfDirectors";
import SecondaryMenu from "../SecondaryMenu";

import toast, { Toaster } from "react-hot-toast";

const MemberCard = ({ person }) => (
  <div className="member-card">
    <div className="member-card__header">
      <div className="member-card__image">
        {person.image ? (
          <>
            <img
              src={`${serverConfig.serverUrl}/img/contact/${person.img}`}
            ></img>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <h3>{person.person[0]}</h3>
          </div>
        )}
      </div>
      <div className="member-card__info">
        <div className="member-card__name">{person.person}</div>
        {person.sub_role && (
          <div className="member-card__role">
            <b>{person.sub_role}</b>
          </div>
        )}
      </div>
    </div>

    {person.mail && (
      <div className="member-card__contact">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-envelope"
          viewBox="0 0 20 20"
        >
          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
        </svg>
        <a href={`mailto:${person.mail}`}>{person.mail}</a>
      </div>
    )}
    {person.phone_number && (
      <div className="member-card__contact">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-telephone"
          viewBox="0 0 20 20"
        >
          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
        </svg>
        {person.phone_number}
      </div>
    )}
    {person.work && (
      <div className="member-card__contact">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-geo-alt"
          viewBox="0 0 20 20"
        >
          <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
          <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
        </svg>

        <span dangerouslySetInnerHTML={{ __html: person.work }} />
      </div>
    )}
  </div>
);

function Contact() {
  const [contentContact, setContentContact] = useState(null);

  useEffect(() => {
    axios
      .get(`${serverConfig.serverUrl}/get_contact`)
      .then((response) => {
        const data = response.data;
        setContentContact(data);
      })
      .catch((error) => {
        toast.error("La risorsa non è al momento disponibile");
      });
  }, []);

  const contentViewBoard = (
    <>
      <div className="board-row">
        {contentContact &&
          contentContact
            .sort((a, b) => a.position - b.position)
            .map((member) => (
              <>
                <MemberCard person={member} />
              </>
            ))}
      </div>
    </>
  );

  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);

  const handleResize = () => {
    if (window.innerWidth > 992) {
      setShowSidebar(true);
    } else {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      <div
        className={`row home-container ${
          showSidebar ? "show-sidebar" : "hide-sidebar"
        }`}
      >
        <Toaster />
        <button
          className="show-sidebar-button"
          onClick={() => setShowSidebar(!showSidebar)}
        >
          {showSidebar ? "Nascondi Menu" : "Mostra Menu"}
        </button>

        {window.innerWidth <= 992 ? (
          showSidebar ? (
            <div className="col-12">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
          ) : (
            <div className={`main-content col-12`}>{contentViewBoard}</div>
          )
        ) : (
          <>
            <div className="col-2 sidebar-left">
              <SecondaryMenu vertical={true}></SecondaryMenu>
            </div>
            <div
              className={`main-content ${showSidebar ? "col-10" : "col-12"}`}
            >
              {contentViewBoard}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Contact;
